import { combineReducers } from 'redux';

import userreducer from './user/user.reducer';
import nextWeekEventReducer from './events/event.reducer';

export default combineReducers({
  user: userreducer,
  events: nextWeekEventReducer,
});